import React, { useEffect } from "react";
import { Form, Formik } from "formik";
import { PeekButton, PeekDialog, PeekDialogContent, PeekDialogActions } from "@piiqtechnologies/ui-components";
import { EditFeatureAccessFormFields, EditFeatureAccessFormValidationSchema } from "./EditFeatureFormConfig";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { useUserAccessPolicy, useNotification, useRefetch, useLoader, useError, } from "@piiqtechnologies/ui-lib";
export const EditFeature = ({ feature, onClose }) => {
    var _a;
    const [updateFeatureAccess, featureAccessUpdated, featureAccessUpdateInProgress, featureAccessUpdateError] = useUserAccessPolicy();
    const { setNotification } = useNotification();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const intl = useIntl();
    const onUpdateFeatureAccess = ({ action }) => {
        updateFeatureAccess({
            action,
            userIds: [feature.userId],
        });
    };
    useEffect(() => {
        setLoader(featureAccessUpdateInProgress, "featureAccessUpdateInProgress");
        return () => setLoader(false, "featureAccessUpdateInProgress");
    }, [featureAccessUpdateInProgress]);
    useEffect(() => {
        if (featureAccessUpdateError) {
            setError(featureAccessUpdateError === null || featureAccessUpdateError === void 0 ? void 0 : featureAccessUpdateError.message);
        }
    }, [featureAccessUpdateError]);
    useEffect(() => {
        if (featureAccessUpdated) {
            setRefetch();
            setNotification(intl.formatMessage(messages.editFeatureAccessSuccess));
            onClose();
        }
    }, [featureAccessUpdated]);
    const EditFeatureAccessFormInitialValues = {
        organization: {
            name: feature.organization.name,
        },
        community: {
            name: ((_a = feature.community) === null || _a === void 0 ? void 0 : _a.name) || "-",
        },
        userName: feature.user.name,
        action: feature.allow.map((feature) => feature.alias),
    };
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, fullWidth: true, title: intl.formatMessage(messages.editFeatureAccess), open: true, onClose: onClose },
        React.createElement(Formik, { initialValues: EditFeatureAccessFormInitialValues, validationSchema: EditFeatureAccessFormValidationSchema(), onSubmit: onUpdateFeatureAccess },
            React.createElement(Form, null,
                React.createElement(PeekDialogContent, null,
                    React.createElement(MultiColumnFormFields, { fullWidth: true, fields: EditFeatureAccessFormFields() })),
                React.createElement(PeekDialogActions, null,
                    React.createElement(PeekButton, { size: "large", fullWidth: true, type: "submit", color: "primary", variant: "contained" }, intl.formatMessage(messages.save)))))));
};
export default EditFeature;
